import { render, staticRenderFns } from "./AtualizarDepartamento.vue?vue&type=template&id=6c0ec497&"
import script from "./AtualizarDepartamento.vue?vue&type=script&lang=js&"
export * from "./AtualizarDepartamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports